import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import { AccountStorage } from "@services/account";
import shortMessage from '@/views-v2/login/components/shortMessage.vue';
var accountStorage = new AccountStorage();
export default {
  data: function data() {
    return {
      isLoginWithPhoneNumber: false
    };
  },
  methods: {
    pullLoginStatus: function pullLoginStatus() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var api, response, data, code;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              api = "/pjyy-deepexi-user-center/api/v1/common/checkToken";
              _context.next = 3;
              return _this.$getHttpClient().get(api);
            case 3:
              response = _context.sent;
              data = response.data;
              code = +data.code;
              if (!(code === 200)) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return", data.data);
            case 8:
              return _context.abrupt("return", false);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    pushLoginOut: function pushLoginOut() {
      var _arguments = arguments,
        _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var updataPwd, URL, result, name;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              updataPwd = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : '';
              URL = "/pjyy-deepexi-user-center/api/v1/common/logout";
              _context2.next = 4;
              return _this2.$getHttpClient().get(URL);
            case 4:
              result = _context2.sent;
              if (result.data.code === "200") {
                accountStorage.removeCacheUserInfo();
                accountStorage.removeCacheAccountId();
                name = _this2.$route.name;
                if (updataPwd === 'updatePwd') {
                  _this2.$router.push({
                    path: "/account/login"
                  });
                } else {
                  if (name === "home") {
                    _this2.$router.go(0);
                  } else {
                    _this2.$router.push({
                      path: "/"
                    });
                  }
                }
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 退出登录
    toLogOut: function toLogOut() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var URL, result, name;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              URL = "/pjyy-deepexi-user-center/api/v1/common/logout";
              _context3.next = 3;
              return _this3.$getHttpClient({
                useResponseToast: false
              }).get(URL);
            case 3:
              result = _context3.sent;
              accountStorage.removeCacheUserList();
              _this3.$root.CurrentMonthStatistics = {};
              name = _this3.$route.name;
              if (result.data.code === "200") {
                if (name === "home") {
                  _this3.$router.go(0);
                } else {
                  _this3.$router.push({
                    name: 'v2-login'
                  });
                }
              } else if (result.data.code === "402" || result.data.code === "401") {
                //如果登录失效点击退出，返回首页
                if (name === "home") {
                  _this3.$emit('update');
                }
                _this3.$router.push({
                  name: 'v2-login'
                });
              }
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 目标客户登录逻辑
    targetCustomerLogin: function targetCustomerLogin() {
      var phone = localStorage.getItem('currentLoggedInPhoneNumber');
      if (phone) {
        this.isLoginWithPhoneNumber = true;

        // 登录页面
        if (this.currentComponent) {
          this.currentComponent.name = 'shortMessage';
          this.currentComponent.components = shortMessage;
        }

        // 手机号登录组件
        if (this.userInfo) this.userInfo.phone = phone;
      }
    }
  }
};